module.exports = __webpack_public_path__ + "img/ic_wuxingxi.e05d4df1.png";